/* Mesmerize · Spotted magazine (sections/mes-spotted-magazine.liquid).
   Port of the Website 3.0 design's _spBegin/_spBuild/_spGo/_spFlash/_spIntro. Geometry and timings are the design's.
   The 24-strip curl is built per turn and removed after it; no rAF runs while idle. Low-end phones (and curl_mode=off)
   get a single-layer 2D slide/fade instead; reduced motion swaps pages instantly with no curl. */
(function () {
  'use strict';
  var RM = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;
  var nav = navigator;
  /* V9.28.219 (Shrey 15 Oct: "pages are sliding" on his phone): Safari exposes no deviceMemory and reports a capped core
     count, so EVERY iPhone counted as low-end and got the slide. Same rule as the 3D viewer and the lead video now: Apple
     devices skip the core test. Android with <= 4 GB reported memory or <= 4 cores still gets the light slide (old-phone jank). */
  var APPLE = /iP(hone|ad|od)/.test(nav.platform || '') || (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1);
  var LOW = (nav.deviceMemory > 0 && nav.deviceMemory <= 4) || (!APPLE && nav.hardwareConcurrency > 0 && nav.hardwareConcurrency <= 4);
  var STRIPS = 24;
  function rm() { return !!(RM && RM.matches); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function easeOut(x) { return 1 - Math.pow(1 - x, 3); }
  function easeIO(x) { return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
  function div(css) { var d = document.createElement('div'); d.style.cssText = css; return d; }
  var FILL = 'position:absolute;top:0;right:0;bottom:0;left:0;';

  /* A page copy for the turn: same pixels, nothing focusable, no ids, ring/tag frozen at their current state. */
  function clonePage(src, ring, note) {
    var cl = src.cloneNode(true);
    ['data-page', 'data-block-id', 'data-shopify-editor-block', 'inert', 'aria-hidden'].forEach(function (a) { cl.removeAttribute(a); });
    Array.prototype.forEach.call(cl.querySelectorAll('[id]'), function (e) { e.removeAttribute('id'); });
    Array.prototype.forEach.call(cl.querySelectorAll('img'), function (e) { e.loading = 'eager'; });
    var cr = cl.querySelector('[data-ring]'), cn = cl.querySelector('[data-note]');
    if (ring && cr) cr.style.strokeDashoffset = ring.dash;
    if (note && cn) { cn.style.opacity = note.op; cn.style.transform = note.tf; }
    return cl;
  }

  /* The design's _spBuild: 24 nested strips, each rotated by the bend between neighbours. */
  function buildCurl(book, src, frozen) {
    var W = book.clientWidth, H = book.clientHeight, N = STRIPS, sw = W / N;
    var root = div('position:absolute;left:0;top:0;width:' + W + 'px;height:' + H + 'px;z-index:60;pointer-events:none;transform-style:preserve-3d');
    var strips = [], parent = root, i;
    for (i = 0; i < N; i++) {
      var s = div('position:absolute;top:0;left:' + (i ? sw : 0) + 'px;width:' + (sw + 3.5) + 'px;height:' + H + 'px;transform-origin:0 50%;transform-style:preserve-3d;outline:1px solid transparent');
      var face = div(FILL + 'overflow:hidden;backface-visibility:hidden;-webkit-backface-visibility:hidden');
      var cl = clonePage(src, frozen.ring, frozen.note);
      cl.style.cssText = 'position:absolute;top:0;left:' + (-i * sw) + 'px;width:' + W + 'px;height:' + H + 'px;transform:none;visibility:visible;box-shadow:none;border-radius:0;overflow:hidden;background:#1C1A17';
      var sh = div(FILL + 'pointer-events:none');
      face.appendChild(cl); face.appendChild(sh);
      var back = div('position:absolute;top:0;bottom:0;left:-1.5px;right:-1.5px;background:#F3EEE4;transform:rotateY(180deg);backface-visibility:hidden;-webkit-backface-visibility:hidden');
      var bsh = div(FILL); back.appendChild(bsh);
      s.appendChild(face); s.appendChild(back); parent.appendChild(s); parent = s;
      strips.push([s.style, sh.style, bsh.style]);
    }
    var cast = div(FILL + 'z-index:59;pointer-events:none;background:linear-gradient(90deg,rgba(0,0,0,.5),rgba(0,0,0,0) 65%);opacity:0');
    var api = { gy: 0, root: root, cast: cast };
    api.set = function (p) {
      var A = 172 * p, curl = Math.sin(p * Math.PI) * 120, tz = api.gy * Math.pow(Math.sin(p * Math.PI), 1.5) * .75, prev = 0;
      /* V9.28.222 (Priyanka 15 Oct, iPhone: "can see lines while it flips"): each strip used ONE flat shade, so neighbouring
         strips stepped in brightness and read as vertical lines. Each strip now runs a gradient from the shade at its left
         edge (the previous strip's) to its own, so the shading is continuous across the 24 strips. */
      var pf = 0, pb = 0;
      for (var j = 0; j < N; j++) {
        var u = j / (N - 1), w = -(A + curl * Math.pow(u, 1.6) - curl * .25 * u), a = w - prev; prev = w;
        strips[j][0].transform = 'rotateY(' + a.toFixed(2) + 'deg) rotateZ(' + (tz * Math.min(1, j / 6)).toFixed(3) + 'deg)';
        var cw = Math.cos(w * Math.PI / 180), sf = Math.max(0, (1 - cw) * .5), sb = Math.max(0, (1 + cw) * .22);
        if (j === 0) { pf = sf; pb = sb; }
        strips[j][1].background = 'linear-gradient(90deg,rgba(0,0,0,' + pf.toFixed(3) + '),rgba(0,0,0,' + sf.toFixed(3) + '))';
        strips[j][2].background = 'linear-gradient(270deg,rgba(70,55,35,' + pb.toFixed(3) + '),rgba(70,55,35,' + sb.toFixed(3) + '))';
        pf = sf; pb = sb;
      }
      cast.style.opacity = (Math.sin(Math.min(p, 1) * Math.PI) * .9).toFixed(3);
      var f = p > .78 ? Math.max(0, (1 - p) / .22) : 1; root.style.opacity = (f * f * (3 - 2 * f)).toFixed(3);
    };
    return api;
  }

  /* Low-end turn: one copy of the page slides left and fades (p = 0 flat, 1 turned), same progress model as the curl. */
  function buildSlide(book, src, frozen) {
    var W = book.clientWidth;
    var root = clonePage(src, frozen.ring, frozen.note);
    root.style.cssText = FILL + 'z-index:60;pointer-events:none;visibility:visible;will-change:transform,opacity';
    var api = { gy: 0, root: root, cast: div('display:none') };
    api.set = function (p) { root.style.transform = 'translate3d(' + (-p * W * .35).toFixed(1) + 'px,0,0)'; root.style.opacity = (1 - p).toFixed(3); };
    return api;
  }

  function Mag(root) {
    var s = this, d = root.dataset;
    s.root = root; s.book = root.querySelector('[data-book]');
    s.pages = Array.prototype.slice.call(root.querySelectorAll('[data-page]'));
    s.N = s.pages.length; s.cur = 0; s.busy = false; s.look = null; s.drag = null; s.active = null; s.timers = [];
    s.left = s.book.querySelector('[data-left]');
    s.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-go]'));
    s.strip = root.querySelector('[data-thumbs]');
    s.count = root.querySelector('[data-count]');
    s.rings = s.pages.map(function (p) { return p.querySelector('[data-ring]'); });
    s.notes = s.pages.map(function (p) { return p.querySelector('[data-note]'); });
    s.turn = +d.turn || 1050; s.scale = s.turn / 1050;
    s.slide = d.curl === 'off' || (d.curl === 'lowend' && LOW);
    s.introSlide = d.introStyle === 'slide'; /* 8 Oct: the 3 automatic intro turns ran 24-strip curls mid-scroll (+5 s jank measured); slide by default */
    s.introOn = d.intro === '1' && !(window.Shopify && Shopify.designMode);
    s.introAt = clamp((+d.introPage || 4) - 1, 0, s.N - 1);
    s.bind();
    s.render(0);
    s.observe();
  }
  var P = Mag.prototype;

  P.hydrate = function (page) {
    var img = page.querySelector('img[data-srcset]');
    if (!img) return;
    img.srcset = img.getAttribute('data-srcset'); img.src = img.getAttribute('data-src');
    img.removeAttribute('data-srcset'); img.removeAttribute('data-src');
  };

  /* The design's state render: k = distance from the current page; only k 0, 1 and N-1 are visible. */
  P.render = function (to) {
    var s = this, N = s.N;
    s.cur = to;
    s.pages.forEach(function (p, i) {
      var k = (i - to + N) % N, vis = k < 2 || k === N - 1;
      p.style.zIndex = N - k; p.style.visibility = vis ? 'visible' : 'hidden';
      if (k) { p.setAttribute('aria-hidden', 'true'); p.setAttribute('inert', ''); } else { p.removeAttribute('aria-hidden'); p.removeAttribute('inert'); }
      if (k < 2) s.hydrate(p); /* current + next only; a turn hydrates its own page first (8 Oct: was 4 pages per position) */
    });
    if (s.left) s.left.style.opacity = to === 0 ? '0' : '1';
    s.thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === to ? 'true' : 'false'); });
    if (s.count) s.count.textContent = pad(to + 1) + ' / ' + pad(N);
    var t = s.thumbs[to], st = s.strip;
    if (t && st && st.scrollWidth > st.clientWidth) {
      var x = t.offsetLeft - st.offsetLeft - (st.clientWidth - t.offsetWidth) / 2;
      if (st.scrollTo) st.scrollTo({ left: x, behavior: rm() ? 'auto' : 'smooth' }); else st.scrollLeft = x;
    }
  };

  /* The design's _spFlash: hide every ring/tag, then draw the current page's ring (1.2s) and pop its tag (1.5s). */
  P.flash = function () {
    var s = this, i = s.cur;
    s.rings.forEach(function (r, j) {
      var n = s.notes[j];
      [r, n].forEach(function (e) { if (e && e.getAnimations) e.getAnimations().forEach(function (a) { a.cancel(); }); });
      if (r) r.style.strokeDashoffset = '1';
      if (n) n.style.opacity = '0';
    });
    var ring = s.rings[i], note = s.notes[i], p = s.pages[i];
    if (rm() || !p.animate) { if (ring) ring.style.strokeDashoffset = '0'; if (note) note.style.opacity = '1'; return; }
    if (ring) ring.animate([{ strokeDashoffset: 1 }, { strokeDashoffset: 1, offset: .2 }, { strokeDashoffset: 0 }], { duration: 1200, easing: 'ease-in-out', fill: 'forwards' });
    if (note) note.animate([{ opacity: 0, transform: 'rotate(-5deg) translateY(-6px) scale(.7)' }, { opacity: 0, transform: 'rotate(-5deg) translateY(-6px) scale(.7)', offset: .65 }, { opacity: 1, transform: 'rotate(-5deg) translateY(0) scale(1)' }], { duration: 1500, easing: 'cubic-bezier(.3,1.4,.5,1)', fill: 'forwards' });
  };

  /* The design's _spBegin. dir 1 = forward (top page turns away), -1 = back (previous page turns in from the left). */
  P.begin = function (dir, gy) {
    var s = this;
    if (s.busy || rm() || s.N < 2) return null;
    var N = s.N, cur = s.cur, to = (cur + dir + N) % N, book = s.book;
    var top = s.pages[cur], si = dir > 0 ? cur : (cur - 1 + N) % N, src = s.pages[si];
    var ring = s.rings[si], note = s.notes[si], frozen = {};
    if (ring) frozen.ring = { dash: getComputedStyle(ring).strokeDashoffset };
    if (note) { var cs = getComputedStyle(note); frozen.note = { op: cs.opacity, tf: cs.transform }; }
    s.hydrate(src);
    var c = (s.slide || s.inIntro ? buildSlide : buildCurl)(book, src, frozen); c.gy = gy || 0;
    c.root.setAttribute('aria-hidden', 'true'); c.root.setAttribute('inert', '');
    var set = c.set, left = s.left;
    if (left && (cur === 0 || to === 0)) set = function (p) { c.set(p); left.style.opacity = p > .5 ? '1' : '0'; };
    s.busy = true; s.closeLook(false);
    set(dir > 0 ? 0 : 1);
    book.appendChild(c.cast); book.appendChild(c.root);
    book.style.zIndex = '90';
    if (dir > 0) top.style.visibility = 'hidden';
    var end = function () { c.root.remove(); c.cast.remove(); book.style.zIndex = ''; s.busy = false; s.active = null; };
    s.active = { end: end };
    var animTo = function (from, target, slow, cb) {
      var t0 = performance.now(), D = slow ? s.turn : (520 * Math.abs(target - from) + 140) * s.scale, ease = slow ? easeIO : easeOut;
      var tick = function (now) {
        if (!s.active) return;
        var q = clamp((now - t0) / D, 0, 1); set(from + (target - from) * ease(q));
        if (q < 1) s.raf = requestAnimationFrame(tick); else cb();
      };
      s.raf = requestAnimationFrame(tick);
    };
    return {
      set: set,
      finish: function (commit, p, btn) {
        if (dir > 0) {
          animTo(p, commit ? 1 : 0, !!btn, function () {
            if (commit) { s.render(to); end(); s.flash(); } else { s.render(cur); end(); }
          });
        } else {
          animTo(p, commit ? 0 : 1, !!btn, function () {
            if (commit) { s.render(to); requestAnimationFrame(function () { end(); s.flash(); }); } else end();
          });
        }
      }
    };
  };

  /* The design's _spGo: one page away animates (buttons: slow ease-in-out); further jumps directly. */
  P.go = function (i) {
    var s = this, N = s.N, cur = s.cur, to = ((i % N) + N) % N;
    if (s.busy || to === cur) return;
    var step = i > cur ? 1 : -1;
    if (rm() || (Math.abs(to - cur) > 1 && !(i === N || i === -1))) { s.closeLook(false); s.render(to); s.flash(); return; }
    var c = s.begin(step);
    if (!c) { s.render(to); return; }
    c.finish(true, step > 0 ? 0 : 1, true);
  };

  P.openLook = function (i, btn) {
    var s = this, card = s.book.querySelector('[data-look="' + i + '"]');
    if (!card) return;
    s.closeLook(false);
    card.hidden = false; btn.setAttribute('aria-expanded', 'true');
    s.look = { card: card, btn: btn };
    var x = card.querySelector('[data-close]'); if (x) x.focus();
  };
  P.closeLook = function (restore) {
    var l = this.look; if (!l) return;
    this.look = null; l.card.hidden = true; l.btn.setAttribute('aria-expanded', 'false');
    if (restore) { try { l.btn.focus({ preventScroll: true }); } catch (e) { l.btn.focus(); } }
  };

  P.bind = function () {
    var s = this, book = s.book, root = s.root, mv = 0, last = null;
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-spot],[data-close],[data-prev],[data-next],[data-go]');
      if (!t) return;
      if (t.hasAttribute('data-spot')) { if (s.look && s.look.btn === t) s.closeLook(true); else s.openLook(t.getAttribute('data-spot'), t); }
      else if (t.hasAttribute('data-close')) s.closeLook(true);
      else if (t.hasAttribute('data-prev')) s.go(s.cur - 1);
      else if (t.hasAttribute('data-next')) s.go(s.cur + 1);
      else s.go(+t.getAttribute('data-go'));
    });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && s.look) { e.stopPropagation(); s.closeLook(true); } });
    root.addEventListener('pointerdown', function () { s.halt = true; });
    book.addEventListener('dragstart', function (e) { e.preventDefault(); });
    book.addEventListener('pointerdown', function (e) {
      if (s.busy || (e.pointerType === 'mouse' && e.button) || e.target.closest('.msm-look')) return;
      s.drag = { x: e.clientX, y: e.clientY, id: e.pointerId };
    });
    book.addEventListener('pointermove', function (e) {
      var g = s.drag; if (!g) return;
      var dx = e.clientX - g.x;
      if (!g.c) {
        if (Math.abs(dx) < 6) return;
        if (rm()) { if (Math.abs(dx) > 40) { s.drag = null; s.go(s.cur + (dx < 0 ? 1 : -1)); } return; }
        try { book.setPointerCapture(g.id); } catch (_) {}
        g.dir = dx < 0 ? 1 : -1;
        var br = book.getBoundingClientRect(); g.W = book.clientWidth;
        g.c = s.begin(g.dir, clamp(((g.y - br.top) / br.height) * 2 - 1, -1, 1));
        if (!g.c) { s.drag = null; return; }
      }
      g.p = g.dir > 0 ? clamp(-dx / (g.W * .85), 0, 1) : clamp(1 - dx / (g.W * .85), 0, 1);
      last = g;
      if (!mv) mv = requestAnimationFrame(function () { mv = 0; if (last && last.c && s.drag === last) last.c.set(last.p); });
    });
    var up = function () {
      var g = s.drag; s.drag = null; if (mv) { cancelAnimationFrame(mv); mv = 0; }
      if (!g || !g.c) return;
      var p = g.p != null ? g.p : (g.dir > 0 ? 0 : 1);
      g.c.set(p); g.c.finish(g.dir > 0 ? p > .3 : p < .7, p);
    };
    book.addEventListener('pointerup', up);
    book.addEventListener('pointercancel', up);
  };

  /* The design's scroll checks, as IntersectionObservers: prep when the book is within 1.8 screens (open it at the intro
     page if it is still more than 0.65 screens down), then run the intro once it crosses the 30-60% band of the screen. */
  P.observe = function () {
    var s = this, book = s.book;
    if (!window.IntersectionObserver) { s.flash(); return; }
    s.io1 = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      s.io1.disconnect();
      if (s.introOn && !rm() && s.cur === 0 && s.introAt > 0 && es[0].boundingClientRect.top > innerHeight * .65) s.render(s.introAt);
    }, { rootMargin: '0px 0px 80% 0px' });
    s.io2 = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      s.io2.disconnect(); s.intro();
    }, { rootMargin: '-30% 0px -40% 0px' });
    s.io1.observe(book); s.io2.observe(book);
  };

  /* The design's _spIntro: from the intro page, flip back to the cover one page at a time; any pointerdown stops it. */
  P.intro = function () {
    var s = this;
    if (rm()) { s.flash(); return; }
    s.halt = false;
    var n = s.introOn && s.cur === s.introAt ? s.introAt : 0, k = 0;
    var later = function (fn, ms) { s.timers.push(setTimeout(fn, ms)); };
    var next = function () {
      if (s.halt || s.dead) return;
      if (s.busy) { later(next, 60); return; }
      if (k >= n) { s.flash(); return; }
      k++;
      s.inIntro = s.introSlide; var c = s.begin(-1); s.inIntro = false; if (!c) return;
      c.finish(true, 1, false);
      later(next, 160);
    };
    later(next, 350);
  };

  P.select = function (blockId) {
    var s = this;
    s.pages.forEach(function (p, i) {
      if (p.getAttribute('data-block-id') !== blockId) return;
      if (s.active) { cancelAnimationFrame(s.raf); s.active.end(); }
      s.halt = true; s.closeLook(false); s.render(i); s.flash();
    });
  };

  P.destroy = function () {
    var s = this; s.dead = true; s.halt = true;
    if (s.io1) s.io1.disconnect(); if (s.io2) s.io2.disconnect();
    s.timers.forEach(clearTimeout);
    if (s.raf) cancelAnimationFrame(s.raf);
    if (s.active) s.active.end();
  };

  function init(root) {
    if (root.__msm || !root.querySelector('[data-book]')) return;
    root.__msm = new Mag(root);
  }
  function each(scope, fn) { Array.prototype.forEach.call((scope || document).querySelectorAll('.msm'), fn); }
  function boot(scope) { each(scope, init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { each(e.target, function (r) { if (r.__msm) { r.__msm.destroy(); r.__msm = null; } }); });
  document.addEventListener('shopify:block:select', function (e) {
    var dt = e.detail || {}, r = document.getElementById('msm-' + dt.sectionId);
    if (r && r.__msm) r.__msm.select(dt.blockId);
  });
})();
